export const alertRangeHint = 'Alarm Range: Values above the Alert Range';
export const processAlertType = 'PROCESS_ALERT';
export const taskAlertType = 'TASK_ALERT';
export const relativeValue = 'relative';
export const thresholdToPrependZero = 9;
export const secondsInAMinute = 60;
export const maxTaskTimeInSeconds = 59940;
export const maxProcessTimeInSeconds = 35996400;

export const ProcessTypeLabelsMap = {
  SCHEDULING: 'Scheduling',
  CHECK_IN: 'Check-In',
  CLINICAL_EVALUATION: 'Clinical Evaluation',
  TREATMENT_CARE: 'Treatment & Care',
  CHECKOUT: 'Checkout',
  INVESTIGATE: 'Investigate'
};

export const AlertType = {
  PROCESS_ALERT: 'process',
  TASK_ALERT: 'task'
};

export enum ProcessAlertRange {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute'
}
